<div
  class="container"
  [ngClass]="{
    'top-item': isFirstItem,
    'bottom-item': isLastItem,
    selected: selected
  }"
>
  <div class="main-information-wrapper">
    <div class="button-container">
      <zaver-radio-button
        [selected]="selected"
        [selectedColor]="radioButtonColor"
      ></zaver-radio-button>
    </div>

    <div class="text-container">
      <div class="title">
        {{ title }}
      </div>
    </div>

    <div
      class="img-container"
      [class.small-mobile-hide]="!!badgeText"
      *ngIf="!!imgSrc || !!badgeText"
    >
      <zaver-badge
        *ngIf="!!badgeText"
        class="no-wrap-badge"
        badgeText="{{ badgeText }}"
        color="{{ color }}"
      >
      </zaver-badge>
    </div>
  </div>

  <!-- Ränterabatt flow -->
   <ng-container *ngIf="isDiscountedInterestRate">
    <div class="bullet-points-wrapper bullet-points-wrapper--interest-discount" *ngIf="selected">
      <div class="your-discount-wrapper">
        <p class="your-discount">{{ yourInterestRate }}</p>
      </div>
      <img class="black-checkmark" src="/assets/icon/Icon-Checkmark-Black.svg" alt="" />
      <div class="bullet-container">
        <div class="bullet" *ngFor="let bullet of bulletPoints">
          <p>{{ bullet }}</p>
        </div>
      </div>
    </div>
    <div class="button-link" *ngIf="selected && link">
      <zaver-button-link [color]="linkColor" [text]="link.text" (click)="link.onClick()"></zaver-button-link>
    </div>
  </ng-container>

  <!-- Normal flow -->
  <ng-container *ngIf="!isDiscountedInterestRate">
    <div class="bullet-points-wrapper" *ngIf="selected">
      <div class="bullet" *ngFor="let bullet of bulletPoints">
        <img src="/assets/icon/Checkmark.svg" alt="" />
        <p>{{ bullet }}</p>
      </div>
    </div>

    <div class="button-link" *ngIf="selected && link">
      <zaver-button-link
        [text]="link.text"
        (click)="link.onClick()"
      ></zaver-button-link>
    </div>
  </ng-container>
</div>
